//import api from '../../api'

// initial state
import api from "../../api";

const state = {
};

// getters
const getters = {};

// actions
const actions = {
    _preOrder ({}, data) {
        return new Promise((resolve, reject)=>{
            api
                .post('/pre-order', data)
                .then(response => {
                    console.log(response);
                    resolve();
                }).catch(error =>{
                    reject(error);
                    console.error(error);
                });
        });

    },
    _checkAddress ({}, data) {
        return new Promise((resolve, reject)=>{
            api
                .post('/fetch-address', data)
                .then(response => {
                    resolve(response.data.data);
                }).catch(error =>{
                    reject(error);
                });
        });

    },
};

// mutations
const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
